export default "__VITE_ASSET__8QjbPkIk__"